 import axios from "axios";

const uploadToCloudinary = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  
  // 🔥 IMPORTANT: Screenshot wala naam yahan daal (Exact spelling)
  formData.append("upload_preset", "borrow time photo"); 
  
  // ✅ Tera Cloud Name (dvhowwkdk)
  const cloud_name = "dvhowwkdk"; 

  try {
    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
      formData
    );
    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary Upload Error:", err);
    throw err;
  }
};

export default uploadToCloudinary;